import { render } from "./OrderEditModal.vue?vue&type=template&id=0a6487a9&scoped=true"
import script from "./OrderEditModal.vue?vue&type=script&lang=js"
export * from "./OrderEditModal.vue?vue&type=script&lang=js"

import "./OrderEditModal.vue?vue&type=style&index=0&id=0a6487a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a6487a9"]])

export default __exports__